import { appLogin, webLogin } from 'actions/User';
import SearchInput from 'components/Search/SearchInput';
import SubscriptionBadge from 'components/Subscription/SubscriptionBadge';
import Icon from 'components/UI/Icon';
import NavItem from 'components/UI/NavItem';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CategoryList from './CategoryList';
import './NavigationModal.scss';
import SupplierList from './SupplierList';
const B2BIcon = require('img/navigationIcons/b2b.svg');
const Subscription = require('img/navigationIcons/subscription.svg');
const Suppliers = require('img/navigationIcons/suppliers.svg');
const UserIcon = require('img/navigationIcons/user.svg');
const Products = require('img/navigationIcons/products.svg');
const Home = require('img/navigationIcons/home.svg');
const CloseButton = require('img/navigationIcons/closebutton.svg');
function NavigationModal({ isShown, hide }) {
    const isApp = useSelector((state) => state.ui.isApp);
    const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const [showSuppliers, setShowSuppliers] = useState(false);
    const [showCategories, setShowCategories] = useState(false);
    const { t } = useTranslation();
    function hideModalAndSetShowCategoriesToFalse() {
        setShowCategories(false);
        hide();
    }
    const loggedInNav = (React.createElement(NavItem, { to: "/my-page" },
        React.createElement("div", { className: 'navigation-modal__navigation-item' },
            React.createElement(Icon, { svg: UserIcon, size: "large" }),
            React.createElement("p", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemMyPage')))));
    const notLoggedInNav = (React.createElement(NavItem, null,
        React.createElement("div", { className: 'navigation-modal__navigation-item', onClick: () => (isApp ? appLogin() : webLogin()) },
            React.createElement(Icon, { svg: UserIcon, size: "large" }),
            React.createElement("p", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemLogIn')))));
    const navigationMenu = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "navigation-modal__search" },
            React.createElement(SearchInput, null)),
        React.createElement("ul", { className: "navigation-modal__navigation-items" },
            React.createElement(NavItem, { to: "/" },
                React.createElement("div", { className: 'navigation-modal__navigation-item' },
                    React.createElement(Icon, { svg: Home, size: "large" }),
                    React.createElement("span", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemHome')))),
            React.createElement(NavItem, null,
                React.createElement("div", { className: 'navigation-modal__navigation-item', onClick: () => setShowCategories(true) },
                    React.createElement(Icon, { svg: Products, size: "large" }),
                    React.createElement("span", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemCategories')))),
            React.createElement(NavItem, null,
                React.createElement("div", { className: 'navigation-modal__navigation-item', onClick: () => setShowSuppliers(true) },
                    React.createElement(Icon, { svg: Suppliers, size: "large" }),
                    React.createElement("span", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemSuppliers')))),
            React.createElement(NavItem, { to: "/subscription" },
                React.createElement("div", { className: 'navigation-modal__navigation-item' },
                    React.createElement(Icon, { svg: Subscription, size: "large" }),
                    React.createElement("span", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemSubscription')),
                    React.createElement(SubscriptionBadge, null))),
            React.createElement(NavItem, { to: "/bedrift", scrollToTop: true },
                React.createElement("div", { className: 'navigation-modal__navigation-item' },
                    React.createElement(Icon, { svg: B2BIcon, size: "large" }),
                    React.createElement("span", { className: 'navigation-modal__navigation-item--text' }, t('mobileNavigationItemB2B')))),
            isLoggedIn ? loggedInNav : notLoggedInNav)));
    const categoryList = (React.createElement(CategoryList, { goBack: () => setShowCategories(false), hide: hideModalAndSetShowCategoriesToFalse }));
    const supplierList = React.createElement(SupplierList, { goBack: () => setShowSuppliers(false) });
    const modal = (React.createElement("div", { className: 'navigation-modal__wrapper' },
        React.createElement("div", { className: 'navigation-modal__content' },
            React.createElement("div", { className: 'navigation-modal__close-icon' },
                React.createElement(Icon, { svg: CloseButton, size: 'large', onClick: () => {
                        setShowSuppliers(false);
                        setShowCategories(false);
                        hide();
                    } })),
            showCategories ? categoryList : showSuppliers ? supplierList : navigationMenu)));
    return isShown ? ReactDOM.createPortal(modal, document.body) : null;
}
export default NavigationModal;
